<template>
  <div id="ht-wrap" >
    <div id="pie"></div>
    <remote-script src="http://webgl.bz-link.net/lib/plugin/ht-flow.js"></remote-script>
    <remote-script src="http://webgl.bz-link.net/lib/plugin/ht-dashflow.js"></remote-script>
  </div>
</template>

<script>
  import "../../assets/js/tools/importJs"
export default {
  name: "energyFlowDiagram",
  data() {
    return {
      dataModel: "",
      graphView: "",
      dm: "",
      offset: "",
      //动画
      direction: 3,
      directionFlag: 0,
      grid_1_anmi: "",
      grid_2_anmi: "",
      grid_4_anmi: "",
      pcs_anmi: "",
      pv_anmi: "",
      battery_anmi: "",
      load_anmi: "",
      //能流虚线变量
      grid_1: "",
      grid_2: "",
      grid_3: "",
      grid_4: "",
      energyFlow_pcs: "",
      energyFlow_pv: "",
      energyFlow_battery: "",
      energyFlow_load: "",
      //接口数据
      pcs_v: "",
      pcs_i: "",
      pcs_p: "",
      battery_v: "",
      battery_i: "",
      battery_SOC: "",
      pv_v: "",
      pv_i: "",
      pv_p: "",
      load_v: "",
      load_i: "",
      load_p: "",
      grid_v: "",
      grid_i: "",
      grid_p: "",
      photovoltaicRate: "",
      bmsRate: "",
      electricityRate: "",
      timer: null,
      firstToken: true,
      screenWidth: document.body.clientWidth
    };
  },
  beforeCreate() {
    window.htUrl("htEnergyFlow");
  },
  watch: {
    screenWidth(val) {
      this.reload(val);
    }
  },
  mounted() {
    this.addGraphView();
    this.interval();
    const that = this;
    setTimeout(() => {
      this.reload(this.screenWidth)
    },30)
    window.onresize = () => (() => {
        window.screenWidth = document.body.clientWidth;
        that.screenWidth = window.screenWidth;
    })();
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    reload(screewidth) {
        if (screewidth > 1680) {
          this.dm.getDataByTag("div").setScale(1,1)
          this.dm.getDataByTag("div").p(300,76)
        } else if (screewidth >= 1440 && 1680> screewidth) {
          this.dm.getDataByTag("div").setScale(0.9,0.9)
          this.dm.getDataByTag("div").p(280,76)
        } else if (screewidth >= 1200 && 1440> screewidth) {
          this.dm.getDataByTag("div").setScale(0.8,0.8)
          this.dm.getDataByTag("div").p(220,76)
        } else if (screewidth >= 960 && 1200> screewidth){
          this.dm.getDataByTag("div").setScale(0.7,0.7)
          this.dm.getDataByTag("div").p(180,76)
        } else if (screewidth >= 720 && 960> screewidth){
          this.dm.getDataByTag("div").setScale(0.6,0.6)
          this.dm.getDataByTag("div").p(100,76)
        } else if(screewidth >= 480 && 720> screewidth){
          this.dm.getDataByTag("div").setScale(0.5,0.5)
          this.dm.getDataByTag("div").p(50,76)
        } else {
          this.dm.getDataByTag("div").setScale(0.4,0.4)
          this.dm.getDataByTag("div").p(50,76)
        }
    },
    addGraphView() {
      this.dataModel = new ht.DataModel(); // 数据容器
      this.graphView = new ht.graph.GraphView(this.dataModel); // 2d 绑定数据模型
      this.dm = this.graphView.dm();
      this.graphView.addToDOM(document.getElementById("ht-wrap"));
      let _this = this;
      this.graphView.deserialize("displays/demo/能流图.json", function() {
        _this.grid_1 = _this.dm.getDataByTag("energyFlow_grid_1");
        _this.grid_2 = _this.dm.getDataByTag("energyFlow_grid_2");
        _this.grid_3 = _this.dm.getDataByTag("energyFlow_grid_3");
        _this.grid_4 = _this.dm.getDataByTag("energyFlow_grid_4");
        _this.energyFlow_pcs = _this.dm.getDataByTag("energyFlow_pcs");
        _this.energyFlow_battery = _this.dm.getDataByTag("energyFlow_battery");
        _this.energyFlow_pv = _this.dm.getDataByTag("energyFlow_pv");
        _this.energyFlow_load = _this.dm.getDataByTag("energyFlow_load");

        _this.pcs_v = _this.dm.getDataByTag("pcs_v");
        _this.pcs_i = _this.dm.getDataByTag("pcs_i");
        _this.pcs_p = _this.dm.getDataByTag("pcs_p");
        _this.battery_v = _this.dm.getDataByTag("battery_v");
        _this.battery_i = _this.dm.getDataByTag("battery_i");
        _this.battery_SOC = _this.dm.getDataByTag("battery_SOC");
        _this.pv_v = _this.dm.getDataByTag("pv_v");
        _this.pv_i = _this.dm.getDataByTag("pv_i");
        _this.pv_p = _this.dm.getDataByTag("pv_p");
        _this.load_v = _this.dm.getDataByTag("load_v");
        _this.load_i = _this.dm.getDataByTag("load_i");
        _this.load_p = _this.dm.getDataByTag("load_p");
        _this.grid_v = _this.dm.getDataByTag("grid_v");
        _this.grid_i = _this.dm.getDataByTag("grid_i");
        _this.grid_p = _this.dm.getDataByTag("grid_p");
        _this.setFlow();
        _this.getData();
      });
    },
    interval() {
      let _this = this;
      this.timer = setInterval(function() {
        _this.getData();
      }, 2000);
    },
    setFlow() {
      //能流电网进线
      this.grid_1_anmi = ht.Default.startAnim({
        frames: Infinity,
        interval: 50,
        action: () => {
          this.offset = this.grid_1.s("shape.dash.offset");
          if(this.directionFlag == 2 || this.directionFlag == 3 || this.directionFlag == 6 || this.directionFlag == 12 || this.directionFlag == 13){
            this.grid_1.s("shape.dash.offset", this.offset - 0);
            this.grid_3.s("shape.dash.offset", this.offset - 0);
            this.grid_2.s("shape.dash.offset", this.offset - 0);
            this.grid_4.s("shape.dash.offset", this.offset - 0);

          }
          if(this.directionFlag == 1 ||this.directionFlag == 4 ||this.directionFlag == 5||this.directionFlag == 7||this.directionFlag == 8||this.directionFlag == 9||this.directionFlag == 10||this.directionFlag == 11){
            this.grid_1.s("shape.dash.offset", this.offset - this.direction);
            this.grid_3.s("shape.dash.offset", this.offset - this.direction);
            this.grid_2.s("shape.dash.offset", this.offset + this.direction);
            this.grid_4.s("shape.dash.offset", this.offset - this.direction);
          }
        }
      });
      // //能流电网进线
      // this.grid_2_anmi = ht.Default.startAnim({
      //   frames: Infinity,
      //   interval: 50,
      //   action: () => {
      //     this.offset = this.grid_2.s("shape.dash.offset");
      //     this.grid_2.s("shape.dash.offset", this.offset + this.direction);
      //   }
      // });
      // //能流电网进线
      // this.grid_4_anmi = ht.Default.startAnim({
      //   frames: Infinity,
      //   interval: 50,
      //   action: () => {
      //     this.offset = this.grid_4.s("shape.dash.offset");
      //     this.grid_4.s("shape.dash.offset", this.offset - this.direction);
      //   }
      // });
      this.pcs_anmi = ht.Default.startAnim({
        frames: Infinity,
        interval: 50,
        action: () => {
          this.offset = this.energyFlow_pcs.s("shape.dash.offset");
          if(this.directionFlag == 8 ||this.directionFlag == 9 ||this.directionFlag == 10 ||this.directionFlag == 11){
            this.energyFlow_pcs.s("shape.dash.offset", this.offset - this.direction);
          }
          if(this.directionFlag == 2 ||this.directionFlag == 3 ||this.directionFlag == 4 ||this.directionFlag == 5 ||this.directionFlag == 6 ||this.directionFlag == 7 ||this.directionFlag == 12){
            this.energyFlow_pcs.s("shape.dash.offset", this.offset + this.direction);
          }
          if(this.directionFlag == 1 || this.directionFlag == 13){
            this.energyFlow_pcs.s("shape.dash.offset", this.offset - 0);
          }
        }
      });
      this.battery_anmi = ht.Default.startAnim({
        frames: Infinity,
        interval: 50,
        action: () => {
          this.offset = this.energyFlow_battery.s("shape.dash.offset");
          if(this.directionFlag == 8 ||this.directionFlag == 9 ||this.directionFlag == 10 ||this.directionFlag == 11 ||this.directionFlag == 12){
            this.energyFlow_battery.s("shape.dash.offset", this.offset - this.direction);
          }else if(this.directionFlag == 2 ||this.directionFlag == 5 ||this.directionFlag == 6 ||this.directionFlag == 7){
            this.energyFlow_battery.s("shape.dash.offset", this.offset + this.direction);
          }else if(this.directionFlag == 1 || this.directionFlag == 3 || this.directionFlag == 4 || this.directionFlag == 13){
            this.energyFlow_battery.s("shape.dash.offset", this.offset + 0);
          }
        }
      });
      this.pv_anmi = ht.Default.startAnim({
        frames: Infinity,
        interval: 50,
        action: () => {
          this.offset = this.energyFlow_pv.s("shape.dash.offset");
          if(this.directionFlag == 1 || this.directionFlag == 2 ||this.directionFlag == 13){
            this.energyFlow_pv.s("shape.dash.offset", this.offset - 0);
          }else if(this.directionFlag == 3 || this.directionFlag == 4 || this.directionFlag == 6|| this.directionFlag == 7 || this.directionFlag == 9|| this.directionFlag == 11){
            this.energyFlow_pv.s("shape.dash.offset", this.offset + this.direction);
          }
        }
      });
      this.load_anmi = ht.Default.startAnim({
        frames: Infinity,
        interval: 50,
        action: () => {
          this.offset = this.energyFlow_load.s("shape.dash.offset");
          if(this.directionFlag == 8 || this.directionFlag == 9 || this.directionFlag == 13){
            this.energyFlow_load.s("shape.dash.offset", this.offset - 0);
          }else{
            this.energyFlow_load.s("shape.dash.offset", this.offset - this.direction);
          }
        }
      });
    },
    getData() {
      let params = "";
      params =
        "TG233:b1_b5:p,TG233:b5_b1-pcs:uab,TG233:b5_b1-pcs:ubc,TG233:b5_b1-pcs:uca,TG233:b5_b1-pcs:ia,TG233:b5_b1-pcs:ib,TG233:b5_b1-pcs:ic,TG233:b5_b1-pcs:p,TG233:b5_b1-bms:u,TG233:b5_b1-bms:i,TG233:b5_b1-bms:soc,TG233:b5_b1-pcs:pv-u,TG233:b5_b1-pcs:pv-i,TG233:b5_b1-pcs:pv-s,TG233:b5_b1-am:dw-uab,TG233:b5_b1-am:dw-ubc,TG233:b5_b1-am:dw-uca,TG233:b5_b1-am:dw-ia,TG233:b5_b1-am:dw-ib,TG233:b5_b1-am:dw-ic,TG233:b5_b1-am:dw-p,TG233:b5_b1-am:fz-uab,TG233:b5_b1-am:fz-ubc,TG233:b5_b1-am:fz-uca,TG233:b5_b1-am:fz-ia,TG233:b5_b1-am:fz-ib,TG233:b5_b1-am:fz-ic,TG233:b5_b1-am:fz-p,TG233:b5_b1-pcs:cdzt,TG233:b5_b1-pcs:fdzt,TG233:b5_b1-pcs:gffddl,TG233:b3_b4:epzyz,TG233:b5_b1-bms:dcdfdljl";
      this.$get("energyflowdiagram/energyflowdiagram", [params]).then(response => {
        this.directionFlag = response.energyFlowDiagram
        this.pcs_v.s(
          "text",
          response.realtimeData["TG233:b5_b1-pcs:uca"] +
            "/" +
            response.realtimeData["TG233:b5_b1-pcs:ubc"] +
            "/" +
            response.realtimeData["TG233:b5_b1-pcs:uab"]
        );
        this.pcs_i.s(
          "text",
          response.realtimeData["TG233:b5_b1-pcs:ia"] +
            "/" +
            response.realtimeData["TG233:b5_b1-pcs:ib"] +
            "/" +
            response.realtimeData["TG233:b5_b1-pcs:ic"]
        );
        this.pcs_p.s("text", response.realtimeData["TG233:b5_b1-pcs:p"]);
        this.battery_v.s("text", response.realtimeData["TG233:b5_b1-bms:u"]);
        this.battery_i.s("text", response.realtimeData["TG233:b5_b1-bms:i"]);
        this.battery_SOC.s(
          "text",
          response.realtimeData["TG233:b5_b1-bms:soc"]
        );
        this.pv_v.s("text", response.realtimeData["TG233:b5_b1-pcs:pv-u"]);
        this.pv_i.s("text", response.realtimeData["TG233:b5_b1-pcs:pv-i"]);
        this.pv_p.s("text", response.realtimeData["TG233:b5_b1-pcs:pv-s"]);
        this.load_v.s(
          "text",
          response.realtimeData["TG233:b5_b1-am:fz-uca"] +
            "/" +
            response.realtimeData["TG233:b5_b1-am:fz-ubc"] +
            "/" +
            response.realtimeData["TG233:b5_b1-am:fz-uab"]
        );
        this.load_i.s(
          "text",
          response.realtimeData["TG233:b5_b1-am:fz-ia"] +
            "/" +
            response.realtimeData["TG233:b5_b1-am:fz-ib"] +
            "/" +
            response.realtimeData["TG233:b5_b1-am:fz-ic"]
        );
        this.load_p.s("text", response.realtimeData["TG233:b5_b1-am:fz-p"]);
        this.grid_v.s(
          "text",
          response.realtimeData["TG233:b5_b1-am:dw-uab"] +
            "/" +
            response.realtimeData["TG233:b5_b1-am:dw-ubc"] +
            "/" +
            response.realtimeData["TG233:b5_b1-am:fz-uca"]
        );
        this.grid_i.s(
          "text",
          response.realtimeData["TG233:b5_b1-am:dw-ia"] +
            "/" +
            response.realtimeData["TG233:b5_b1-am:dw-ib"] +
            "/" +
            response.realtimeData["TG233:b5_b1-am:dw-ic"]
        );
        this.grid_p.s("text", response.realtimeData["TG233:b5_b1-am:dw-p"]);
        this.photovoltaicRate = response.photovoltaicRate;
        this.bmsRate = response.bmsRate;
        this.electricityRate = response.electricityRate;
        if(this.firstToken){
          this.drawPie();
          this.firstToken = !this.firstToken;
        }
      });
    },
    drawPie() {
      var echarts = require("echarts");
      var myChart = echarts.init(document.getElementById("pie"));
      myChart.setOption({
        title: {
          text: "负载用电占比",
          left: "center",
          top: 10,
          textStyle: {
            color: "#ccc"
          }
        },
        tooltip: {
          trigger: "item",
          formatter: "{b} : {c} ({d}%)"
        },
        legend: {
          orient: "horizontal",
          bottom: 10,
          data: ["光伏", "bms", "市电"],
          textStyle: {
            color: "#fff"
          }
        },
        color: ["#79A0FD", "#0E72E3", "#EF7184"],
        series: [
          {
            type: "pie",
            radius: "40%",
            avoidLabelOverlap: true,
            itemStyle: {
              normal: {
                label: {
                  textStyle: {
                    fontSize: "12",
                    fontWeight: "bolder",
                    color: 'rgba(255, 255, 255)'
                  },
                  show: true,
                  formatter: "{d}%"
                },
                labelLine: { show: true }
              }
            },
            data: [
              { value: this.photovoltaicRate.toFixed(2), name: "光伏" },
              { value: this.bmsRate.toFixed(2), name: "bms" },
              { value: this.electricityRate.toFixed(2), name: "市电" }
            ]
          }
        ]
      });
    }
  }
};
</script>

<style scoped lang="scss">
#ht-wrap {
// margin: 0 auto;
  width: 50%;
//   height: 800px;
//   position: relative;
  #pie {
    position: relative;
    width: 280px;
    height: 280px;
    top: 450px;
    left: 1300px;
    z-index: 5000;
  }
}
@media screen and (width:3440px) and (height: 1440px )   {
  #ht-wrap {
margin: 0 auto !important;
  height: 800px !important;
    position: relative;
  }
    }
    @media screen and (width:3840px) and (height: 1080px )   {
    #ht-wrap {
      margin: 0 auto !important;
  height: 800px !important;
    position: relative;
    }
    }
</style>
